<script setup lang="ts">
import { Translation, useI18n } from 'vue-i18n';
import { computed } from 'vue';

import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppButton } from '@libs/ui';

import seaportImage from '../../../../../../assets/add_ferry.png';

interface AppStenaFerryCardMobileEmits {
  (eventName: 'add'): void;
}

const emit = defineEmits<AppStenaFerryCardMobileEmits>();

const { t } = useI18n();

const browserStore = useBrowserStore();

const title = computed<string>(() =>
  browserStore.isSmallDevice
    ? t('planner.transport.upsell.add_ferry')
    : t('planner.transport.upsell.stena_ferry.title')
);
</script>

<template>
  <div class="add-stena-ferry-card-mobile">
    <div class="content">
      <div class="image">
        <img :src="seaportImage" alt="seaport image" />
      </div>
      <div class="info-wrapper">
        <div class="header">
          {{ title }}
        </div>
        <div class="description">
          <Translation
            keypath="planner.transport.upsell.stena_ferry.paragraph_one"
            tag="span"
          >
            <template #discount>
              <span class="highlighted">
                {{ $t('planner.transport.upsell.stena_ferry.discount') }}
              </span>
            </template>
          </Translation>
        </div>
      </div>
    </div>

    <AppButton
      class="button"
      type="secondary"
      state="enabled"
      size="small"
      :icon="{ name: 'plus' }"
      @click="emit('add')"
    >
      {{ $t('planner.transport.add_ferry') }}
    </AppButton>
  </div>
</template>

<style scoped lang="scss">
.add-stena-ferry-card-mobile {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-12);
  box-shadow: var(--shadow-elevation-200);
  border-radius: var(--border-radius-12);
  overflow: hidden;
  background-color: var(--color-white);
  gap: var(--spacing-12);

  .content {
    display: grid;
    grid-template-columns: 30% 70%;
    gap: var(--spacing-12);
    .image {
      position: relative;
      border-radius: var(--border-radius-8);
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info-wrapper {
      .header {
        @include font-heading-5;
        color: var(--color-secondary-40);
        margin-bottom: var(--spacing-12);
      }

      .description {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-8);
        @include font-body-s-light;
        color: var(--color-secondary-60);
        .highlighted {
          @include font-body-s-bold;
        }
      }
    }
  }
}
</style>
